/* Parametri selezionati per l'utlimo caricamento dei dati
null | {"type": machine_type, "axis": axis, "stage": stage}
*/
import { createContext } from "react";
const loadedSelectionsContext = createContext({
    loadedSelections: null,
    setLoadedSelections: (axis) => {}
  });
export default loadedSelectionsContext;